import { useAppDispatch } from '@/Application/Hooks/Redux';
import { setKioscoOrderIntentError } from '@/modules/perseo-billing/store/slices/billing';
import type { IErrorResponse } from '@/modules/perseo-billing/utils/error-handler';

export default function useOnCreateIntentErrorInKiosco() {
  const dispatch = useAppDispatch();

  const handleKioscoError = (data: IErrorResponse | null) => {
    dispatch(setKioscoOrderIntentError(data ?? null));
  };

  return { handleKioscoError };
}
